import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      // Emergent Google OAuth callback: exchange session_id first
      if (window.location.hash && window.location.hash.includes("session_id=")) {
        const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
        try {
          const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
          setUser(data.user);
        } catch (e) {
          /* ignore, fall through to unauthenticated */
        } finally {
          window.history.replaceState(null, "", window.location.pathname);
          setLoading(false);
        }
        return;
      }
      // Normal check: JWT (localStorage) or Google session (cookie)
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
      } catch (e) {
        localStorage.removeItem("tubmix_token");
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("tubmix_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("tubmix_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/studio";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("tubmix_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, loginWithGoogle, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
